import { SmartHold } from "#webapp/src/__schema__";
import { DirectionsCar, DirectionsRun, Headset, Restaurant } from "@material-ui/icons";
import React from "react";

type GoalWithIconProps = {
  holdName: SmartHold["__typename"];
};

const SmartHoldIconMap: Record<SmartHold["__typename"], JSX.Element> = {
  FocusTimeHold: <Headset />,
  LunchHold: <Restaurant />,
  MeetingReliefHold: <DirectionsRun />,
  TravelTimeHold: <DirectionsCar />,
};

export const GoalWithIcon = ({
  holdName,
  children,
}: React.PropsWithChildren<GoalWithIconProps>) => {
  const smartHoldIcon = React.cloneElement(SmartHoldIconMap[holdName], {
    fontSize: "inherit",
    className: "cw-text-positive",
  });

  return (
    <div className="cw-flex cw-body-base cw-items-start cw-gap-2 cw-mt-6">
      <div className="cw-rounded-full cw-bg-positive cw-p-[5px] cw-flex cw-items-center cw-justify-center">
        {smartHoldIcon}
      </div>
      {children}
    </div>
  );
};
